<template>
  <div class="flex">
    <div class="inline-flex gap-x-2">
      <TooltipWrapper>
        <router-link :to="{ name: LingoRouteName.STAKING_NEW }">
          <BalanceBadge
            color="#00C8FF"
            is-gradient-to-transparent
          >
            <template #icon>
              <InlineSvg
                :src="shardsIcon"
                width="24"
                height="24"
              />
            </template>
            {{ formattedAvailableCredits }}
          </BalanceBadge>
        </router-link>
        <template #content>
          <div class="flex w-max max-w-none flex-col gap-2 p-4">
            <p class="whitespace-nowrap text-base font-semibold leading-4 tracking-[-0.16px] text-lavender">
              {{ t('header.balance.creditsTooltipTitle') }}
            </p>
          </div>
        </template>
      </TooltipWrapper>

      <TooltipWrapper>
        <BalanceBadge
          color="#8C74FF"
          is-gradient-to-transparent
        >
          <template #icon>
            <InlineSvg
              :src="lingoIcon"
              width="24"
              height="24"
            />
          </template>
          {{ formattedTokenBalance }}
        </BalanceBadge>
        <template #content>
          <TooltipContent
            :title="t('header.balance.available')"
            :description="t('header.balance.availableDescription')"
          />
        </template>
      </TooltipWrapper>

      <TooltipWrapper>
        <BalanceBadge
          color="#FF7847"
          is-gradient-to-transparent
        >
          <template #icon>
            <InlineSvg
              :src="powerIcon"
              width="24"
              height="24"
            />
          </template>

          {{ formattedPowerMiles }}
        </BalanceBadge>
        <template #content>
          <PowerMilesTooltipContent />
        </template>
      </TooltipWrapper>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import InlineSvg from 'vue-inline-svg'
import BalanceBadge from '@/components/user-balance/BalanceBadge.vue'
import shardsIcon from '@/assets/icons/shards.svg'
import powerIcon from '@/assets/images/game/power.svg'
import lingoIcon from '@/assets/images/lingo-icon.svg'
import { useBalance } from '@/composables/contracts/balance'
import { useStakes } from '@/composables/contracts/stakes'
import { useTranslation } from '@/composables/use-i18n'
import { LingoRouteName } from '@/router/routes'
import TooltipWrapper from '../TooltipWrapper.vue'
import TooltipContent from '../TooltipContent.vue'
import PowerMilesTooltipContent from './PowerMilesTooltipContent.vue'

const { t } = useTranslation()
const { tokenBalance } = useBalance()
const { totalPowerMiles, availableCredits } = useStakes()

const formattedAvailableCredits = computed(() => {
  return Number(availableCredits.value).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
})

const formattedTokenBalance = computed(() => {
  return Number(tokenBalance.value).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
})

const formattedPowerMiles = computed(() => {
  return Number(totalPowerMiles.value).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
})
</script>
